import styled from "styled-components";

const bp = { sm: "560px", md: "768px", lg: "1100px" };

export const Page = styled.div`
  min-height: calc(100vh - 220px);
  background: #fffdfa;
  padding: 200px 16px 80px;
`;

export const Card = styled.div`
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  background: #ffffff;
  border: 1px solid rgba(201, 162, 39, 0.2);
  border-radius: 24px;
  box-shadow: 0 18px 50px rgba(20, 20, 20, 0.08);
  padding: 32px;

  @media (max-width: ${bp.md}) {
    padding: 22px;
    border-radius: 18px;
  }
`;

export const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 8px 14px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 18px;
  background: ${({ $status }) =>
    $status === "success"
      ? "rgba(201, 162, 39, 0.14)"
      : $status === "failed"
        ? "rgba(180, 55, 55, 0.12)"
        : "rgba(20,20,20,0.08)"};
  color: ${({ $status }) =>
    $status === "success"
      ? "#8d6a00"
      : $status === "failed"
        ? "#a03232"
        : "#4b4b4b"};
`;

export const Title = styled.h1`
  margin: 0 0 14px;
  font-size: clamp(28px, 4vw, 42px);
  line-height: 1.1;
  color: #141414;
  font-family: Georgia, "Times New Roman", serif;
`;

export const Text = styled.p`
  margin: 0 0 18px;
  font-size: 16px;
  line-height: 1.7;
  color: rgba(20, 20, 20, 0.75);
`;

export const InfoBox = styled.div`
  margin-top: 14px;
  padding: 16px 18px;
  border-radius: 18px;
  background: #fffdfa;
  border: 1px solid rgba(201, 162, 39, 0.18);
  color: #141414;
  line-height: 1.7;
`;

export const OrderNumber = styled.div`
  margin-top: 6px;
  font-weight: 700;
  letter-spacing: 0.06em;
`;

export const ButtonRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 28px;
`;

export const PrimaryBtn = styled.button`
  border: none;
  border-radius: 999px;
  padding: 14px 22px;
  cursor: pointer;
  background: #141414;
  color: white;
  font-weight: 700;
`;

export const SecondaryBtn = styled.button`
  border: 1px solid rgba(20, 20, 20, 0.14);
  border-radius: 999px;
  padding: 14px 22px;
  cursor: pointer;
  background: white;
  color: #141414;
  font-weight: 700;
`;
